"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createNonInitialisedError = void 0;
var _default = function _default() {
  throw new Error('Initialize i18n with the Provider before calling any internationalization methods');
};
exports.default = _default;
var createNonInitialisedError = function createNonInitialisedError(name) {
  return function () {
    throw new Error("Initialize i18n with the Provider before calling the ".concat(name, " method."));
  };
};
exports.createNonInitialisedError = createNonInitialisedError;